export enum CheckRequirementType {
  FaceMatch = 'FACE_MATCH',
  IproovMatch = 'FACE_IPROOV',
  IproovExpress = 'FACE_EXPRESS',
  VoiceMatch = 'VOICE_MATCH',
  Mfa = 'MFA',
}
